export default __webpack_public_path__ + "static/883-511eef2c581b0399e15e563d934f139d.gif";